import React, { Fragment } from 'react'
import { Empty } from 'antd';
import { MsgLoader } from '../reuse/SVG';
import { convertTimeToCurrentTimeZone, getHtml } from '../../helper';
import MessageTypeBadge from '../inboxPage/MessageTypeBadge';

const ChatComponent = ({inboxUser, filterUser, setFilterUser, getMessages, isSelected, currentChatUser, messageEl, 
    handleScroll, messages, msgLoader, userProfile, inputHeight, handleMsgChange, sendMessage, textMessage}) => {
    return (
        <div className="page_card_body p-0">
            <div className="d-flex chat_wrapper">
                <div className="cht_users" style={{width:'360px'}}>
                    <div className="contact_search">
                        <i className="icon-search" />
                        <input type="text" value={filterUser} onChange={e => setFilterUser(e.target.value)} placeholder="Search" />
                    </div>

                    <ul>
                        {
                            inboxUser.length ? inboxUser.map(item => (
                                <li key={item.groupId} className="d-flex align-items-center" onClick={() => getMessages(item)}>

                                    {item.type === 1 ? item.userId?.length ? <Fragment>
                                        <img className="chat_user_img" src={item.userId[0].profileImage ? item.userId[0].profileImage : require('../../assets/img/user.png')} alt='' />
                                        <div>
                                            <p>{item.userId[0].name} {item.count ? <span className="msg_count">{item.count}</span> : ''}</p>
                                        </div>
                                    </Fragment> : '' : ''}


                                    {item.type === 2 ? <Fragment>
                                        <img className="chat_user_img" src={item.groupImage ? item.groupImage : require('../../assets/img/user.png')} alt='' />
                                        <p>{item.groupName}</p>
                                    </Fragment> : ''}


                                </li>
                            )) : <li className="cm_empty"><Empty description="Data Not Found" /></li>
                        }
                    </ul>

                </div>




                <div className={`d-flex w-100 flex-column chat_box ${isSelected ? '' : 'd_none'}`}>
                    <div className="mb-auto d-flex align-items-center chat_user_head">

                        <img className="chat_user_img" src={currentChatUser.profileImage ? currentChatUser.profileImage : require("../../assets/img/user.png")} alt='' />
                        <p><b className="d-block">{currentChatUser.name}</b></p>
                    </div>


                    <div id="chat__screen" ref={messageEl} onScroll={handleScroll} className={`chat_screen ${msgLoader ? 'no_scroll' : ''}`}>
                        {msgLoader ? <div className="msg_loader"><MsgLoader /></div> : ''}
                        <div className="chat_msgs">



                            {

                                messages.length ? messages.map((message, i) => (
                                    <React.Fragment key={i}>
                                        {
                                            message.senderId === userProfile._id ?
                                                <div key={message.timeStamp} className="chat_msg me_user">
                                                    <div className="d-flex align-items-center cm_name_m">
                                                        <MessageTypeBadge type={message?.messageType} />
                                                        <time className='ms-3'>
                                                            {convertTimeToCurrentTimeZone(message.timeStamp, userProfile?.timezone, 'hh:mm a, (MMM Do YYYY)')}
                                                        </time>
                                                    </div>
                                                    {/* <p>{message.message}</p> */}
                                                    <div className="msg_text">{message.message ? getHtml(message.message) : ''} </div>
                                                </div>
                                                :
                                                <div key={message.timeStamp} className="chat_msg other_user">
                                                    <img className="chat_user_img" src={message.profileImage ? message.profileImage : require("../../assets/img/user.png")} alt='' />
                                                    <div className="cm_name_m d-flex align-items-center">{message.name}
                                                        <time className='me-3'>
                                                            {convertTimeToCurrentTimeZone(message.timeStamp, userProfile?.timezone, 'hh:mm a, (MMM Do YYYY)')}
                                                        </time>
                                                        <MessageTypeBadge type={message?.messageType} />
                                                    </div>
                                                    <div className="msg_text">{message.message ? getHtml(message.message) : ''} </div>
                                                </div>

                                        }
                                    </React.Fragment>
                                )) : ''
                            }
                        </div>
                    </div>


                    <div className="mt-auto chat_text_area">
                        <textarea
                            onChange={handleMsgChange}
                            value={textMessage}
                            onKeyPress={e => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    sendMessage()
                                }
                            }}
                            className="form-control"
                            style={{ height: `${inputHeight * 30}px` }}
                            placeholder="type a message"
                        ></textarea>
                        <span className="send_btn" onClick={sendMessage}><i className="icon-send" /></span>
                    </div>
                </div>



                <div className={`chat_welcom_screen ${isSelected ? 'd_none' : ''}`}>
                    <div className="chat_welcom_inner">
                        <img src={userProfile?.profileImage ? userProfile?.profileImage : require('../../assets/img/user.png')} alt={userProfile?.name} />
                        <h4>Welcome back {userProfile?.name}</h4>
                    </div>
                </div>



            </div>
        </div>
    )
}

export default ChatComponent

